import React from "react";
import PrePlayCommon from "../components/PrePlayCommon";
import ReadingActive from "../components/ReadingActive";

const GAHReading = ({
  roomId,
  prompt,
  status,
  isReading,
  playerObj,
  played_cards,
  isActivePlayer
}) => {
  const question =
    prompt.replace(/<br\s*\/?>/gm, "\n").replace(/\[BLANK]/g, "________") || "";

  return isActivePlayer ? (
    <ReadingActive
      roomId={roomId}
      status={status}
      prompt={question}
      isReading={isReading}
      played_cards={played_cards}
    />
  ) : (
    <PrePlayCommon status={status} playerObj={playerObj} />
  );
};

export default GAHReading;
